import React from 'react';

export const SecurityIcon = () => (
  <svg viewBox="0 0 24 24" className="icon icon-primary">
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
  </svg>
);

export const CameraIcon = () => (
  <svg viewBox="0 0 24 24" className="icon icon-small">
    <path d="M12 15.2c1.74 0 3.15-1.41 3.15-3.15S13.74 8.9 12 8.9s-3.15 1.41-3.15 3.15S10.26 15.2 12 15.2z M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9z"/>
  </svg>
);

export const LightIcon = () => (
  <svg viewBox="0 0 24 24" className="icon icon-small">
    <path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zM12 5c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1z"/>
  </svg>
);

export const NetworkIcon = () => (
  <svg viewBox="0 0 24 24" className="icon icon-small">
    <path d="M1 9l2-2v8h8l-2 2H3c-1.1 0-2-.9-2-2V9zm21-4h-8l2-2h6c1.1 0 2 .9 2 2v6l-2 2V5zm-10 4l-4 4h3v4h2v-4h3l-4-4z"/>
  </svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" className="icon-status icon-success">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </svg>
);

export const ErrorIcon = () => (
  <svg viewBox="0 0 24 24" className="icon-status icon-error">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
  </svg>
);

export const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" className="icon icon-white">
    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
  </svg>
);

export const BigCameraIcon = () => (
  <svg viewBox="0 0 24 24" className="icon-large">
    <path d="M12 15.2c1.74 0 3.15-1.41 3.15-3.15S13.74 8.9 12 8.9s-3.15 1.41-3.15 3.15S10.26 15.2 12 15.2z M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9z"/>
  </svg>
);

export const BigCheckIcon = () => (
  <svg viewBox="0 0 24 24" className="icon-xlarge icon-success">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </svg>
); 